import { useTranslation } from 'next-i18next';
import React from 'react';

import LeadButton from '@/components/LeadButton';
import TrustpilotMicroStar from '@/components/TrustpilotBar/MicroStar';

const Trustpilot: React.FC = () => {
  const { t } = useTranslation(['home']);

  return (
    <div className="mt-[40px] flex flex-col items-center xl:mt-[60px]">
      <div className=" z-10 text-center lg:text-left">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_FirstModule_CTAClick"
          traceGa4Name="new_entry_How_FirstModuleCTA">
          {t('banner-按钮')}
        </LeadButton>
      </div>
      <div className="mt-[20px] flex justify-center lg:mt-[28px] xl:mt-[32px]">
        <TrustpilotMicroStar className="w-full max-w-[280px]" />
      </div>
    </div>
  );
};

export default Trustpilot;
